<crowdctrl-unauthenticated-page
  [pageTitle]="pageTitle"
  [showFooter]="false"
  defaultHref="/about/how-it-works"
>
  <div class="about-project">
    <crowdctrl-unauth-page-intro>
      <h1 crowdctrlUnauthIntroTitle><strong>CrowdCTRL Service</strong></h1>
      <p crowdctrlUnauthIntroLead>
        Live teaching and lab operations: workspaces, sessions, queues, and shared visibility.
      </p>
    </crowdctrl-unauth-page-intro>

    <section class="about-project__section">
      <p class="about-project__text">
        When the bell goes, staff and students run the session in
        <strong>CrowdCTRL Service</strong>. They open workspaces and sessions, join queues, raise
        and progress requests, read overview and wait-time context, and use the controls that keep
        the floor moving. Everything in a session is shared in real time so demonstrators,
        lecturers, and students are looking at the same picture of who needs help next.
      </p>
    </section>

    <a
      href="/about/how-it-works"
      class="about-project__back-link"
      (click)="unauthNav.forward($event, '/about/how-it-works')"
      >Back to How it all works</a
    >
  </div>
</crowdctrl-unauthenticated-page>
